import React from 'react';
import { Stack, ModalOverlay } from '@moda/om';

import './ShippingAddressModal.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  onClose: () => void;
}

export const ShippingAddressModal: React.FC<Props> = ({ children, onClose }) => (
  <ModalOverlay className="ShippingAddressModal" onClose={onClose}>
    <Stack className="ShippingAddressModal__content" space={6}>
      {children}
    </Stack>
  </ModalOverlay>
);
